import React from "react";
import { EnterCodeStep } from "./steps/EnterCodeStep";
import { EnterPhoneNumberStep } from "./steps/EnterPhoneNumberStep";

export const SignIn: React.FC<{
  onComplete: () => void;
  size?: "sm" | "lg";
}> = ({ onComplete }) => {
  const [step, setStep] = React.useState<"enter-phone" | "enter-code">("enter-phone");

  return (
    <div className="w-full">
      {step === "enter-phone" && <EnterPhoneNumberStep nextStep={() => setStep("enter-code")} />}
      {step === "enter-code" && (
        <EnterCodeStep onComplete={onComplete} onRequestRestart={() => setStep("enter-phone")} />
      )}
    </div>
  );
};
